<script>
export default {
  props: {
    // 活性状態
    disable: {
      type: Boolean,
      required: true,
    },
    // サイズ 'large' | 'default' | 'small'
    size: {
      type: String,
      default: 'default',
    },
    value: {
      type: String,
      required: true,
    },
    options: {
      // [{label: 'ラベル', value: '値'}] の形式
      type: Array,
      required: true,
      validator: function(value) {
        if (!Array.isArray(value)) return false
        return value.every(function(el) {
          return typeof el === 'object' && 'label' in el && 'value' in el
        })
      },
    },
    // 縦並びかどうか
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<template>
  <el-radio-group v-model="modelValue" :disabled="disable" :class="{ vertical: vertical }">
    <el-radio v-for="item in options" :key="item.value" :label="item.value" :size="size">
      {{ item.label }}
    </el-radio>
  </el-radio-group>
</template>

<style scoped>
.left-align {
  text-align: left;
}

.vertical {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}
</style>
